import publicRoutes from './config/publicRoutes.json';

const KEY = 'virgil_analytics_attribution';
const SOURCES = ['chatgpt', 'claude', 'google', 'bing', 'other', 'direct_or_unknown'];
const METHODS = ['utm_source', 'referrer', 'unknown'];
const MAX_AGE = 24 * 60 * 60 * 1000;
let initialVisit;
let attribution;
let expiresAt = 0;

export function publicPage(pathname) {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return publicRoutes.includes(normalized) ? normalized : 'other';
}

export function classifyVisit(href, referrer) {
  const url = new URL(href);
  const utm = (url.searchParams.get('utm_source') || '').toLowerCase();
  const aliases = {
    chatgpt: 'chatgpt', 'chatgpt.com': 'chatgpt', openai: 'chatgpt',
    claude: 'claude', 'claude.ai': 'claude', 'claude.com': 'claude',
    google: 'google', bing: 'bing',
  };
  let source = Object.prototype.hasOwnProperty.call(aliases, utm) ? aliases[utm] : null;
  let method = source ? 'utm_source' : 'unknown';
  if (!source && referrer) {
    try {
      const hostname = new URL(referrer).hostname.toLowerCase();
      const matches = (domain) => hostname === domain || hostname.endsWith(`.${domain}`);
      source = matches('chatgpt.com') || matches('chat.openai.com') ? 'chatgpt'
        : matches('claude.ai') || matches('claude.com') ? 'claude'
        : matches('google.com') ? 'google'
        : matches('bing.com') ? 'bing' : 'other';
      method = 'referrer';
    } catch { source = 'other'; }
  }
  return { source: source || 'direct_or_unknown', source_method: method, landing_page: publicPage(url.pathname) };
}

// Keep only coarse categories in memory until analytics consent is granted.
export function initializeAttribution() {
  initialVisit = classifyVisit(window.location.href, document.referrer);
  attribution = undefined;
}

export function clearAttribution() {
  attribution = undefined;
  try { sessionStorage.removeItem(KEY); } catch {}
}

export function getAttribution() {
  if (attribution && Date.now() < expiresAt) return attribution;
  attribution = undefined;
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY));
    if (saved && SOURCES.includes(saved.source) && METHODS.includes(saved.source_method)
      && (saved.landing_page === 'other' || publicRoutes.includes(saved.landing_page))
      && typeof saved.created_at === 'number' && saved.created_at <= Date.now()
      && Date.now() - saved.created_at < MAX_AGE) {
      expiresAt = saved.created_at + MAX_AGE;
      attribution = { source: saved.source, source_method: saved.source_method, landing_page: saved.landing_page };
    }
  } catch {}
  if (!attribution) {
    expiresAt = Date.now() + MAX_AGE;
    attribution = initialVisit || classifyVisit(window.location.href, document.referrer);
    try { sessionStorage.setItem(KEY, JSON.stringify({ ...attribution, created_at: Date.now() })); } catch {}
  }
  return attribution;
}
